import { post, get } from '@/api/request';

/**
 * 新增配置
 * @param {*} data 
 * @returns 
 */
export const reminderSaveOrUpdate = data => {
    return post('/sysReminderConfig/saveOrUpdate', data);
};

/**
 * 查询列表
 * @param {*} data 
 * @returns 
 */
export const reminderQueryPage = data => {
    return post('/sysReminderConfig/queryList', data);
};

/**
 * 查询详情
 * @param {*} configId 
 * @returns 
 */
export const reminderDetail = configId => {
    return get(`/sysReminderConfig/queryById?id=${configId}`);
};

/**
 * 删除数据
 * @param {*} configId 
 * @returns 
 */
export const reminderDelete = configId => {
    return get(`/sysReminderConfig/delete?id=${configId}`);
};
